var _style, _g, _path, _path2, _path3, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoInternet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 890 700.5",
    style: {
      enableBackground: "new 0 0 890 700.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#2F2E41;}\n\t.st2{fill:#C7C7C7;}\n\t.st3{fill:none;stroke:#3F3D56;stroke-width:0.828;stroke-miterlimit:10;}\n\t.st4{fill:#3F3D56;}\n\t.st5{opacity:0.1;enable-background:new    ;}\n\t.st6{fill:#888888;}\n\t.st7{fill:#FFFFFF;}\n\t.st8{opacity:0.3;fill:#C7C7C7;enable-background:new    ;}\n\t.st9{fill:#FEFEFE;}\n\t.st10{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\n\t.st11{fill:#C6C6C6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_page_not_found_su7k",
    transform: "translate(49 237.528)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    className: "st0",
    cx: 553.7,
    cy: -530.8,
    rx: 437,
    ry: 28.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    className: "st1",
    d: "M537-847.4c-71.2,0-122.3,45.7-122.3,152.2c0,120.8,51.1,152.8,122.3,152.8s125.4-35,125.4-152.8 C662.3-821,608.2-847.4,537-847.4z M537.5-582.5c-49.3,0-75.1-28.9-75.1-112.6c0-73.8,26.8-112.7,76.1-112.7s76.1,25.6,76.1,112.7 C614.6-613.6,586.8-582.5,537.5-582.5L537.5-582.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    className: "st2",
    d: "M372-626.7h-29.4v-86.7c0-9.6-7.8-17.4-17.4-17.4c0,0,0,0,0,0h-6.9c-9.6,0-17.4,7.8-17.4,17.4 l0,0v86.7h-83c-5.5,0-9.9-4.4-9.9-9.9c0-1.6,0.4-3.2,1.1-4.6l87.9-166.3c4.5-8.5,1.2-19-7.2-23.5c-0.2-0.1-0.5-0.2-0.7-0.3 l-5.2-2.5c-8.4-4-18.4-0.6-22.7,7.5L154.1-625.8c-1.8,3.4-2.8,7.2-2.8,11.1l0,0c0,13,10.5,23.5,23.5,23.5H301v54.8 c0,11.5,9.3,20.8,20.8,20.8c0,0,0,0,0,0l0,0c11.5,0,20.8-9.3,20.8-20.8l0,0v-54.8H372c9.8,0,17.8-8,17.8-17.8l0,0 C389.8-618.7,381.9-626.7,372-626.7L372-626.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st2",
    d: "M917.1-626.7h-29.4v-86.7c0-9.6-7.8-17.4-17.4-17.4h-6.9c-9.6,0-17.4,7.8-17.4,17.4c0,0,0,0,0,0 v86.7h-83c-5.5,0-9.9-4.4-9.9-9.9c0-1.6,0.4-3.2,1.1-4.6l87.9-166.3c4.5-8.5,1.2-19-7.2-23.5c-0.2-0.1-0.5-0.2-0.7-0.3l-5.2-2.5 c-8.4-4-18.4-0.6-22.7,7.5L699.1-625.8c-1.8,3.4-2.8,7.2-2.8,11.1l0,0c0,13,10.5,23.5,23.5,23.5l0,0H846v54.8 c0,11.5,9.3,20.8,20.8,20.8l0,0l0,0c11.5,0,20.8-9.3,20.8-20.8c0,0,0,0,0,0v-54.8h29.4c9.8,0,17.8-7.9,17.8-17.8c0,0,0,0,0,0l0,0 C934.9-618.7,926.9-626.7,917.1-626.7C917.1-626.7,917.1-626.7,917.1-626.7L917.1-626.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    className: "st3",
    d: "M380.2-636.8h-29.4v-86.7c0-9.6-7.8-17.4-17.4-17.4h-6.9c-9.6,0-17.4,7.8-17.4,17.4l0,0v86.7h-83 c-5.5,0-9.9-4.4-9.9-9.9c0-1.6,0.4-3.2,1.1-4.6l87.9-166.3c4.5-8.5,1.2-19-7.2-23.5c-0.2-0.1-0.5-0.2-0.7-0.3l-5.2-2.5 c-8.4-4-18.4-0.6-22.7,7.5L162.2-635.9c-1.8,3.4-2.8,7.2-2.8,11.1l0,0c0,13,10.5,23.5,23.5,23.5h126.2v54.8 c0,11.5,9.3,20.8,20.8,20.8c0,0,0,0,0,0l0,0c11.5,0,20.8-9.3,20.8-20.8l0,0v-54.8h29.4c9.8,0,17.8-7.9,17.8-17.8l0,0 C397.9-628.9,390-636.8,380.2-636.8L380.2-636.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    className: "st3",
    d: "M932.3-636.8h-29.4v-86.7c0-9.6-7.8-17.4-17.4-17.4h-6.9c-9.6,0-17.4,7.8-17.4,17.4c0,0,0,0,0,0 v86.7h-83c-5.5,0-9.9-4.4-9.9-9.9c0-1.6,0.4-3.2,1.1-4.6l87.9-166.3c4.5-8.5,1.2-19-7.2-23.5c-0.2-0.1-0.5-0.2-0.7-0.3l-5.2-2.5 c-8.4-4-18.4-0.6-22.7,7.5L714.3-635.9c-1.8,3.4-2.8,7.2-2.8,11.1l0,0c0,13,10.5,23.5,23.5,23.5l0,0h126.2v54.8 c0,11.5,9.3,20.8,20.8,20.8l0,0l0,0c11.5,0,20.8-9.3,20.8-20.8l0,0v-54.8h29.4c9.8,0,17.8-7.9,17.8-17.8l0,0 C950.1-628.9,942.1-636.8,932.3-636.8C932.3-636.8,932.3-636.8,932.3-636.8L932.3-636.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    className: "st3",
    d: "M553.2-856.6c-71.2,0-122.3,45.7-122.3,152.2c0,120.8,51.1,152.8,122.3,152.8 s125.4-35,125.4-152.8C678.6-830.2,624.4-856.6,553.2-856.6z M553.7-591.7c-49.3,0-75.1-28.9-75.1-112.6 c0-73.8,26.8-112.7,76.1-112.7s76.1,25.6,76.1,112.7C630.9-622.7,603-591.7,553.7-591.7L553.7-591.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    className: "st4",
    d: "M583.2-833.2c-0.6,2.6-3.4,4.8-6.5,6.2c-6.5,3.1-14.4,4-22.2,4.4c-2,0.1-4,0.1-5.9-0.1 c-3.8-0.4-7.4-2-10.1-4.7c-0.6-0.4-0.8-1.3-0.4-1.9c0.1-0.2,0.3-0.3,0.4-0.4c4.1-4.5,11-7.3,17.9-9.3c5.2-1.5,14.4-5.4,20.1-4.9 C582.1-843.4,584-836.5,583.2-833.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    className: "st5",
    d: "M583.2-833.2c-0.6,2.6-3.4,4.8-6.5,6.2c-6.5,3.1-14.4,4-22.2,4.4c-2,0.1-4,0.1-5.9-0.1 c-3.8-0.4-7.4-2-10.1-4.7c-0.6-0.4-0.8-1.3-0.4-1.9c0.1-0.2,0.3-0.3,0.4-0.4c4.1-4.5,11-7.3,17.9-9.3c5.2-1.5,14.4-5.4,20.1-4.9 C582.1-843.4,584-836.5,583.2-833.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    className: "st6",
    d: "M939.9-638.2c8.9,3.3,18.8-1.4,22.1-10.3c3.3-8.9-1.4-18.8-10.3-22.1c-3-1.1-6.3-1.3-9.5-0.7 l0.4,8.9l-4.2-7.6c-4.1,1.9-7.3,5.4-8.8,9.7c-0.5,1.5-0.9,3.1-1,4.7C928.1-648,932.7-640.9,939.9-638.2L939.9-638.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    className: "st3",
    d: "M960.7-535.3c-1.5-7.5,4.9-14.2,11.3-18.6s13.8-8.6,15.9-16c3.1-10.6-6.2-20.3-13.4-28.7 c-5.3-6.2-9.9-13-13.7-20.3c-1.6-2.9-2.7-6-3.3-9.2c-0.6-4.7,0.9-9.4,2.5-13.9c5.1-14.9,10.5-29.8,16.3-44.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    className: "st3",
    d: "M940.6-640.5c8.9,3.3,18.8-1.4,22.1-10.3c3.3-8.9-1.4-18.8-10.3-22.1c-3-1.1-6.3-1.3-9.5-0.7 l0.4,8.9l-4.2-7.6c-4.1,1.9-7.3,5.4-8.8,9.7c-0.5,1.5-0.9,3.1-1,4.7C928.8-650.3,933.4-643.2,940.6-640.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    className: "st6",
    d: "M958.6-689.6c2-5.5,6.7-9.6,12.4-10.9l1.4,8.4l2.6-8.9c9.5,0.1,17.1,8,17,17.5 c-0.1,9.5-8,17.1-17.5,17c-9.5-0.1-17.1-8-17-17.5C957.6-685.9,957.9-687.8,958.6-689.6L958.6-689.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    className: "st3",
    d: "M959.5-692.6c2-5.5,6.7-9.6,12.4-10.9l1.4,8.4l2.6-8.9c9.5,0.1,17.1,8,17,17.5 c-0.1,9.5-8,17.1-17.5,17s-17.1-8-17-17.5C958.5-688.9,958.9-690.8,959.5-692.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    className: "st6",
    d: "M971.5-598.4c8.9,3.2,18.8-1.4,22.1-10.3c2.7-7.5-0.1-16-6.8-20.3l-2,6.8l-1.4-8.5c0,0,0,0,0,0 c-9-3.2-18.8,1.5-22,10.4C958-611.5,962.6-601.7,971.5-598.4L971.5-598.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    className: "st3",
    d: "M972.3-601.5c8.9,3.2,18.8-1.4,22.1-10.3c2.7-7.5-0.1-16-6.8-20.3l-2,6.8l-1.4-8.5c0,0,0,0,0,0 c-8.9-3.3-18.8,1.3-22.1,10.2c-3.3,8.9,1.3,18.8,10.2,22.1C972.2-601.6,972.3-601.5,972.3-601.5L972.3-601.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    className: "st6",
    d: "M953.6-569.8c1.6,9.4,10.6,15.6,20,14c9.4-1.6,15.6-10.6,14-20c-1.6-9.4-10.6-15.6-20-14 c-4.2,0.7-8,3-10.7,6.5l7.7,11.6l-10.5-6.1C953.2-575.3,953.1-572.5,953.6-569.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    className: "st3",
    d: "M954.3-572.1c1.6,9.4,10.6,15.6,20,14c9.4-1.6,15.6-10.6,14-20c-1.6-9.4-10.6-15.6-20-14 c-4.2,0.7-8,3-10.7,6.5l7.7,11.6l-10.5-6.1C954-577.6,953.8-574.8,954.3-572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    className: "st6",
    d: "M113.4-596.2c5.9,2.1,12.4-0.9,14.5-6.8c2.1-5.9-0.9-12.4-6.8-14.5c-2-0.7-4.2-0.9-6.2-0.4 l0.3,5.8l-2.8-5c-2.7,1.3-4.8,3.6-5.8,6.4c-0.4,1-0.6,2-0.7,3.1C105.6-602.7,108.6-598,113.4-596.2L113.4-596.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    className: "st3",
    d: "M127-528.6c-1-5,3.2-9.4,7.4-12.2s9-5.7,10.5-10.5c2-7-4-13.3-8.8-18.9c-3.5-4.1-6.5-8.6-9-13.4 c-1.1-1.9-1.8-3.9-2.2-6.1c-0.4-3.1,0.6-6.2,1.6-9.1c3.3-9.8,6.9-19.5,10.7-29.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    className: "st3",
    d: "M113.8-597.7c5.9,2.1,12.4-0.9,14.5-6.8c2.1-5.9-0.9-12.4-6.8-14.5c-2-0.7-4.2-0.9-6.2-0.4 l0.3,5.8l-2.8-5c-2.7,1.3-4.8,3.6-5.8,6.4c-0.4,1-0.6,2-0.7,3.1C106-604.2,109.1-599.5,113.8-597.7L113.8-597.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    className: "st6",
    d: "M125.6-630c1.3-3.6,4.4-6.3,8.2-7.2l0.9,5.5l1.7-5.8c6.3,0.1,11.2,5.2,11.2,11.5 c-0.1,6.3-5.2,11.2-11.5,11.2c-6.3-0.1-11.2-5.2-11.2-11.5C125-627.5,125.2-628.8,125.6-630L125.6-630z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    className: "st3",
    d: "M126.2-632c1.3-3.6,4.4-6.3,8.2-7.2l0.9,5.5l1.7-5.8c6.3,0.1,11.2,5.2,11.2,11.5 c-0.1,6.3-5.2,11.2-11.5,11.2c-6.3-0.1-11.2-5.2-11.2-11.5C125.6-629.5,125.8-630.8,126.2-632L126.2-632z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    className: "st6",
    d: "M134.1-570.1c5.9,2.1,12.4-0.9,14.5-6.8c1.8-5-0.1-10.5-4.5-13.4l-1.3,4.5l-0.9-5.6l0,0 c-5.9-2.1-12.4,0.9-14.5,6.8C125.2-578.8,128.2-572.3,134.1-570.1C134.1-570.1,134.1-570.1,134.1-570.1L134.1-570.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    className: "st3",
    d: "M134.6-572.1c5.9,2.1,12.4-0.9,14.5-6.8c1.8-4.9-0.1-10.5-4.5-13.3l-1.3,4.5l-0.9-5.6l0,0 c-5.9-2.1-12.4,0.9-14.5,6.8C125.7-580.8,128.7-574.3,134.6-572.1C134.6-572.1,134.6-572.1,134.6-572.1L134.6-572.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    className: "st6",
    d: "M122.3-551.3c1.1,6.2,7,10.3,13.1,9.2s10.3-7,9.2-13.1c-1.1-6.2-7-10.3-13.1-9.2 c-2.8,0.5-5.3,2-7,4.2l5,7.6l-6.9-4C122.1-554.9,122-553.1,122.3-551.3L122.3-551.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    className: "st3",
    d: "M122.8-552.8c1.1,6.2,7,10.3,13.1,9.2c6.2-1.1,10.3-7,9.2-13.1c-1.1-6.2-7-10.3-13.1-9.2 c-2.8,0.5-5.3,2-7,4.2l5,7.6l-6.9-4C122.6-556.4,122.5-554.6,122.8-552.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    className: "st1",
    cx: 504.3,
    cy: -721.4,
    rx: 14.1,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    className: "st1",
    cx: 580.9,
    cy: -721,
    rx: 14.1,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    className: "st1",
    d: "M570.1-667.2c0,8.2-11.5,14.9-25.7,14.9s-25.7-6.7-25.7-14.9c0-7.1,8.6-13.1,20.1-14.6 c1.8-0.2,3.7-0.4,5.5-0.4c3.1,0,6.2,0.3,9.2,1C563.3-679,570.1-673.5,570.1-667.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    className: "st3",
    cx: 507.6,
    cy: -725.6,
    rx: 14.1,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    className: "st3",
    cx: 584.2,
    cy: -725.2,
    rx: 14.1,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    className: "st3",
    cx: 547.8,
    cy: -671.3,
    rx: 25.7,
    ry: 14.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    className: "st7",
    d: "M554-679.9c0,1-0.4,2-1.1,2.8c-0.7,0.7-1.6,1.2-2.6,1.2H542c-2.1-0.1-3.8-1.9-3.7-4 c0-0.8,0.2-1.6,0.7-2.3c1.8-0.3,3.7-0.4,5.5-0.4c3.1,0,6.2,0.3,9.2,1.1C553.9-680.9,554-680.4,554-679.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    className: "st7",
    cx: 507.6,
    cy: -730.5,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    className: "st7",
    cx: 584.6,
    cy: -730.5,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    className: "st8",
    cx: 588.8,
    cy: -691.6,
    r: 4.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    className: "st8",
    cx: 487.7,
    cy: -691.6,
    r: 4.1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1652.1-596.2c160.9,0,321.9,0,482.8-0.1c3.7,0,4.6,0.8,4.6,4.6c-0.1,167.5-0.1,334.9,0,502.4 c0,3.7-0.8,4.6-4.6,4.6c-167.4-0.1-334.8-0.1-502.2,0c-3.7,0-4.6-0.8-4.6-4.6c0.1-111.5,0.1-223,0.1-334.4c0.3,0.3,0.8,0.6,1,1 c7,15.7,22.4,18.9,34.4,6.6c18.3-18.7,38-35.6,60.1-49.7c3-1.9,4.6-2.2,7.4,0.6c15.9,16.3,32.1,32.3,48.2,48.4c1,1,2.4,1.8,2.8,3.7 c-12.9,6.2-25.4,13.2-37.3,21.4c-13.7,9.5-26.5,20-38.1,32c-7.7,8-7.6,19.6-0.3,27.4c7.2,7.8,18.9,8.4,27.4,1.4 c2-1.7,3.9-3.6,5.8-5.4c20.3-19.5,43.5-34.6,69.7-45.2c2.9-1.2,4.5-0.9,6.8,1.4c19.1,19.4,38.5,38.6,57.7,57.9 c0.9,0.9,2.2,1.5,2.3,3.2c-1.5,0.2-2.9,0.6-4.4,0.7c-19,1.5-36.6,7.5-53.3,16.3c-12.4,6.6-23.6,14.8-33.6,24.6 c-7,6.9-8,17.2-2.8,25.1c5.1,7.7,15,11,23.7,7.8c4.8-1.8,8.1-5.7,11.9-8.8c24.1-19.7,50.9-30.3,82.5-23.6c15.8,3.3,29.5,10,41.3,22 c52.9,53.7,106.4,106.8,159.8,160.2c1.8,1.8,3.5,3.5,5.5,5c11.4,8.5,27.2,2.9,31-10.8c2.5-9.2-1.6-15.9-7.9-22.1 c-154.2-154.2-308.4-308.4-462.6-462.7C1662.7-590,1658.2-594.1,1652.1-596.2z M1878.5-551.4c-23.7,0.4-47,3.3-70.1,8.2 c-11.4,2.4-18.6,12.9-16.3,23.5c2.4,11.3,12.5,18,24.4,15.5c35.7-7.4,71.6-9.4,107.8-4.4c44.2,6,85,21.1,122.4,45.3 c21,13.6,39.7,29.9,57.1,47.8c8.6,8.8,20.8,8.8,28.8,0.7c7.9-8,7.9-19.9-0.5-28.6C2063-515.5,1978.3-551.2,1878.5-551.4z  M1923.9-432c-10.4-0.2-18.1,5.4-20.7,14c-2.6,8.6,0.8,17.8,8.4,22.6c3.2,2,6.7,2.8,10.3,3.5c23.3,4.7,45,13.2,65.4,25.3 c16.1,9.6,30.4,21.3,43.9,34.2c9,8.5,21.1,8.4,28.9,0.3c8-8.4,7.3-20.5-1.6-29.3c-27-26.5-57.9-46.9-93.5-59.8 C1951.1-426.2,1937.1-430,1923.9-432z M1882.5-131.7c18-0.2,32.9-15.3,32.6-33.2c-0.3-17.9-15-32.5-32.8-32.5c-18,0-33,15-32.9,33 C1849.5-146.5,1864.6-131.6,1882.5-131.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1628.2-571.3c3.1,6.7,8.3,11.7,13.4,16.8c18,17.9,35.8,36,53.9,53.7c3.1,3,2.4,4.2-0.7,6.3 c-21.1,14-40.2,30.3-57.8,48.5c-3.6,3.7-6.4,7.8-8.8,12.3C1628.2-479.6,1628.2-525.4,1628.2-571.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1644.1-596.2c-7.7,2.5-12.8,7.7-15.9,15c0-4.9-1.9-12,0.5-14.1c2.8-2.5,9.5-0.7,14.5-0.8 C1643.5-596.2,1643.8-596.2,1644.1-596.2z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    className: "st0",
    d: "M637.9,282.7C609.4,170.7,511,89.8,395.4,86.5C334.3,84.8,270,105.1,223.2,176 c-83.7,126.7,5.1,214.3,67.1,255.9c29.9,20.1,56.9,44.4,80.1,72c41.8,49.6,122.3,111.3,218.1,14.7 C657.9,448.5,656.9,357.3,637.9,282.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    className: "st10",
    cx: 753,
    cy: 285.4,
    rx: 11.1,
    ry: 13.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    className: "st10",
    cx: 137,
    cy: 277.2,
    rx: 11.1,
    ry: 13.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    className: "st4",
    d: "M745.7,530.9c0,30-140.9,83.1-314.6,83.1S132.9,506.3,132.9,476.4c0-30,124.4,29.2,298.1,29.2 S745.7,501,745.7,530.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    className: "st5",
    d: "M745.7,530.9c0,30-140.9,83.1-314.6,83.1S132.9,506.3,132.9,476.4c0-30,124.4,29.2,298.1,29.2 S745.7,501,745.7,530.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    className: "st4",
    d: "M745.7,530.6c0,30-140.9,54.2-314.6,54.2s-298.1-78.5-298.1-108.5c0-30,124.4,0,298.1,0 S745.7,500.7,745.7,530.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    className: "st1",
    d: "M383,446.2l-6.4,40.7c0,0-31.4,16.7-9.3,17.2c22.1,0.5,126,0,126,0s20.1,0-11.8-17.6l-6.4-42.6 L383,446.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    className: "st5",
    d: "M362.8,503.6c4.3-3.5,8.9-6.5,13.7-9.1l6.4-40.7l92.1,0.1l6.4,40.1c5.2,2.7,10.2,5.9,14.7,9.7 c4.1-0.9,8.6-4.4-14.7-17.3l-6.4-42.6l-92.1,2.4l-6.4,40.7C376.6,486.9,350.2,500.9,362.8,503.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    className: "st1",
    d: "M235.6,162.7h385.9c8.1,0,14.6,6.5,14.6,14.6v260c0,8.1-6.5,14.6-14.6,14.6H235.6 c-8.1,0-14.6-6.5-14.6-14.6v-260C221,169.2,227.5,162.7,235.6,162.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    x: 234.9,
    y: 178.1,
    className: "st4",
    width: 387.2,
    height: 216.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    className: "st11",
    cx: 428.5,
    cy: 171.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    className: "st1",
    d: "M636.1,411.9v25.3c0,8.1-6.5,14.6-14.6,14.6c0,0,0,0,0,0H235.6c-8.1,0-14.6-6.5-14.6-14.6 c0,0,0,0,0,0v-25.3H636.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    className: "st1",
    d: "M536.9,530.5v4.9H273.2v-3.9l0.4-1l6.5-17.6h251.4L536.9,530.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    className: "st1",
    d: "M638.3,525.7c-0.5,2.1-2.3,4.2-6.4,6.3c-14.7,7.4-44.6-2-44.6-2s-23-3.9-23-14.2 c0.6-0.4,1.3-0.8,2-1.2c6.2-3.3,26.7-11.3,63,0.3c2.7,0.8,5.1,2.4,6.9,4.5C637.9,521.1,638.7,523.4,638.3,525.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    className: "st5",
    d: "M638.3,525.7c-18,6.9-34,7.4-50.5-4c-6.2-4.6-13.8-7.1-21.5-7.1c6.2-3.3,26.7-11.3,63,0.3 c2.7,0.8,5.1,2.4,6.9,4.5C637.9,521.1,638.7,523.4,638.3,525.7z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    className: "st0",
    cx: 615.8,
    cy: 519.7,
    rx: 6.4,
    ry: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    className: "st11",
    cx: 428.5,
    cy: 432,
    r: 9.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    className: "st5",
    d: "M536.9,530.5v4.9H273.2v-3.9l0.4-1L536.9,530.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    className: "st10",
    cx: 678.8,
    cy: 180.1,
    rx: 11.1,
    ry: 13.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M357.8,208.3c1.8,0.6,3.2,1.9,4.6,3.3c47.2,47.2,94.4,94.4,141.5,141.6c1.9,1.9,3.2,3.9,2.4,6.8 c-1.2,4.2-6,5.9-9.5,3.3c-0.6-0.5-1.1-1-1.7-1.5c-16.3-16.3-32.7-32.6-48.9-49c-3.6-3.7-7.8-5.7-12.6-6.7 c-9.7-2-17.9,1.2-25.2,7.2c-1.2,1-2.2,2.2-3.6,2.7c-2.6,1-5.7,0-7.2-2.4c-1.6-2.4-1.3-5.6,0.9-7.7c3.1-3,6.5-5.5,10.3-7.5 c5.1-2.7,10.5-4.5,16.3-5c0.4,0,0.9-0.1,1.3-0.2c0-0.5-0.4-0.7-0.7-1c-5.9-5.9-11.8-11.8-17.7-17.7c-0.7-0.7-1.2-0.8-2.1-0.4 c-8,3.2-15.1,7.9-21.3,13.8c-0.6,0.6-1.2,1.1-1.8,1.7c-2.6,2.1-6.2,2-8.4-0.4c-2.2-2.4-2.3-5.9,0.1-8.4c3.5-3.7,7.5-6.9,11.6-9.8 c3.6-2.5,7.5-4.7,11.4-6.5c-0.1-0.6-0.5-0.8-0.8-1.1c-4.9-4.9-9.9-9.8-14.7-14.8c-0.8-0.9-1.3-0.7-2.3-0.2 c-6.8,4.3-12.8,9.5-18.4,15.2c-3.7,3.7-8.4,2.8-10.5-2c-0.1-0.1-0.2-0.2-0.3-0.3c0-1,0-2,0-3.1c0.7-1.4,1.6-2.6,2.7-3.8 c5.4-5.6,11.3-10.5,17.7-14.8c1-0.6,1.2-1,0.2-1.9c-5.5-5.4-11-11-16.5-16.4c-1.6-1.6-3.2-3.1-4.1-5.1c0-1,0-2,0-3.1 c1-2.2,2.5-3.8,4.9-4.6C356.2,208.3,357,208.3,357.8,208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M427.1,222.1c30.5,0.1,56.4,11,77.6,33.1c2.5,2.7,2.6,6.3,0.1,8.7c-2.5,2.5-6.2,2.5-8.8-0.2 c-5.3-5.5-11-10.5-17.5-14.6c-11.4-7.4-23.9-12-37.5-13.9c-11.1-1.5-22.1-0.9-33,1.4c-3.6,0.8-6.7-1.3-7.5-4.7 c-0.7-3.2,1.5-6.4,5-7.2C412.7,223.1,419.8,222.2,427.1,222.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M441,258.6c4,0.6,8.3,1.8,12.5,3.3c10.9,3.9,20.4,10.2,28.6,18.3c2.7,2.7,3,6.4,0.5,9 c-2.4,2.5-6.1,2.5-8.8-0.1c-4.1-3.9-8.5-7.5-13.4-10.5c-6.2-3.7-12.9-6.3-20-7.8c-1.1-0.2-2.2-0.5-3.1-1.1 c-2.3-1.5-3.3-4.3-2.6-6.9C435.4,260.2,437.8,258.5,441,258.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M428.3,350.5c-5.5,0.1-10.1-4.5-10.1-10c0-5.5,4.6-10.1,10.1-10.1c5.5,0,10,4.5,10.1,9.9 C438.4,345.8,433.8,350.4,428.3,350.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternet);
export default __webpack_public_path__ + "static/media/no-internet.cb769c0fdc71a62b2d242a47f9d97ec0.svg";
export { ForwardRef as ReactComponent };